module.exports = __webpack_public_path__ + "static/media/dr3.c7bf58dc.jpeg";